import { FC, useEffect, useState } from "react";
import { Col, Row } from "antd";
import Icon from "@assets/icon_config";
import Measures from "./measures";
import SupplementalFile from "./supplemental-file/supplementalFile";
import { useMemberDetailsStore } from "@stores/memberDetailsStore";
import { getTransformedHealthPlanName } from "@utils/helpers";

const CareGaps: FC<any> = (props) => {
  const defaultExpandedCards = ["39"];
  const expandAllCards = ["39", "40"];
  const [activePanels, setActivePanels] = useState<any>(defaultExpandedCards);
  const [memberData] = useMemberDetailsStore((state) => [state.memberData]);
  const healthPlanName = memberData?.payorName?.trim();
  const transformedHealthPlanName = getTransformedHealthPlanName(healthPlanName?.toLowerCase());
  const isHealthPlanValid = !!transformedHealthPlanName;
  
  const changeCollapse = () => {
    if (activePanels?.length > 0) {
      setActivePanels([]);
    } else {
      setActivePanels(isHealthPlanValid ? expandAllCards : defaultExpandedCards);
    }
  };

  useEffect(() => {
    setActivePanels(defaultExpandedCards);
  }, [memberData?.patientId]);

  return (
    <>
      <div className="member-detail-tab-header">
        <div className="member-detail-tab-header__collapse-all-button" onClick={changeCollapse}>
          <span className="member-detail-tab-header__collapse-all-button__title">{activePanels?.length > 0 ? "Collapse All" : "Expand All"} </span>
          <span className={`member-detail-tab-header__collapse-all-button__arrow ${activePanels?.length > 0 ? "" : "arrow-down"}`}>
            <Icon name={`${activePanels?.length > 0 ? "arrowUp" : "arrowDown"}`} colorOfBrand={"#0072E3"} />
          </span>
        </div>
      </div>
      <div>
        <Row>
          <Col span={24}>
            <Measures pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels} />
          </Col>
        </Row>
        <Row>
        <Col span={24}>
            <SupplementalFile pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels} memberData={memberData} isHealthPlanValid={isHealthPlanValid} transformedHealthPlanName={transformedHealthPlanName}/>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default CareGaps;
